var exports = {
  "u": "spinner__G1U7NO",
  "U": "safe-html-box__Uwc6Al",
};

module.exports = exports;
